<div id="search-result-panel" [@showHide]="{
            value: (isPanelShown | async) ? 'show' : 'hide',
            params: { height: height }
        }">
    <div id="search-result-content" class="aa-scrollable-y aa-scrollbar">
        <aa-its2-request-search-category [category]="categories.get('its2-request')">
        </aa-its2-request-search-category>
        <aa-bckp-job-search-category [category]="categories.get('bckp-job')">
        </aa-bckp-job-search-category>
        <aa-bckp-server-search-category [category]="categories.get('bckp-server')">
        </aa-bckp-server-search-category>
        <aa-bckp-policy-search-category [category]="categories.get('bckp-policy')">
        </aa-bckp-policy-search-category>
        <aa-comp-instance-search-category [category]="categories.get('comp-instance')">
        </aa-comp-instance-search-category>
        <aa-back-auth-entity-category [category]="categories.get('back-auth-entity')">
        </aa-back-auth-entity-category>
        <aa-back-auth-user-category [category]="categories.get('back-auth-user')">
        </aa-back-auth-user-category>
    </div>
    <aa-search-toolbar class="toolbar"></aa-search-toolbar>
</div>
